import React, { useState, useEffect } from "react";
import ReactSelect from "react-select";
import _ from "lodash";
import { default_tags } from "../constants/default";

const FeedTags = ({
  onChangeTags,
  articles = [],
  hot_topic_tags = [],
  events = [],
  products = [],
  isVisible,
  feed,
  trackModification,
}) => {
  const [tags, setTags] = useState(default_tags);
  const [modification, setModification] = useState({});
  useEffect(() => {
    const shallow_tags = { ...tags };
    Object.keys(shallow_tags).forEach((key) => {
      shallow_tags[key] = shallow_tags[key] ? shallow_tags[key].id || "" : "";
    });
    onChangeTags(shallow_tags);
  }, [tags]);
  useEffect(() => {
    let newFeed = { ...feed };
    if (feed) {
      if (feed.event_tag) {
        const event = events.find((event) => event.id === feed.event_tag);
        newFeed.event_tag = event;
      }
      if (feed.hot_topic) {
        const hotTopic = hot_topic_tags.find(
          (hotTopic) => hotTopic.value.id === feed.hot_topic
        );
        newFeed.hot_topic = hotTopic.value;
        newFeed.hot_topic.tag = hotTopic.label;
      }
      if (feed.article_tag) {
        const article = articles.find(
          (article) => article.id === feed.article_tag
        );
        newFeed.article_tag = article;
      }
      setTags(newFeed);
    }
  }, [feed, events, articles, hot_topic_tags, products]);
  useEffect(() => {
    if (trackModification) trackModification(modification);
  }, [modification]);
  const handleSelectHotTopic = (value) => {
    const newtag = _.cloneDeep(tags);
    newtag["hot_topic"] = value.value;
    setTags(newtag);
    // modification tracking..
    let newModification = {
      ...modification,
      hot_topic: (value.value && value.value.id) || null,
    };
    setModification(newModification);
  };
  const handleSelectEvent = (value) => {
    const newtag = _.cloneDeep(tags);
    newtag["event_tag"] = value.value;
    setTags(newtag);
    // modification tracking..
    let newModification = {
      ...modification,
      event_tag: (value.value && value.value.id) || null,
    };
    setModification(newModification);
  };
  const handleSelectArticle = (value) => {
    const newtag = _.cloneDeep(tags);
    newtag["article_tag"] = value.value;
    setTags(newtag);
    // modification tracking..
    let newModification = {
      ...modification,
      article_tag: (value.value && value.value.id) || null,
    };
    setModification(newModification);
  };
  const handleSelectProduct = (value) => {
    const newtag = _.cloneDeep(tags);
    newtag["product_tag"] = value.value;
    setTags(newtag);
    // modification tracking..
    let newModification = {
      ...modification,
      product_tag: (value.value && value.value.id) || null,
    };
    setModification(newModification);
  };
  const handleInputEventChange = (inputValue, action) => {
    if (action.action !== "input-blur" && action.action !== "menu-close") {
      const newtag = _.cloneDeep(tags);
      newtag["event_tag"] = inputValue;
      setTags(newtag);
      // modification tracking..
      let newModification = {
        ...modification,
        event_tag: (inputValue && inputValue.id) || null,
      };
      setModification(newModification);
    }
  };
  const handleInputProductChange = (inputValue, action) => {
    if (action.action !== "input-blur" && action.action !== "menu-close") {
      const newtag = _.cloneDeep(tags);
      newtag["product_tag"] = inputValue;
      setTags(newtag);
      // modification tracking..
      let newModification = {
        ...modification,
        product_tag: (inputValue && inputValue.id) || null,
      };
      setModification(newModification);
    }
  };
  const handleInputArticleChange = (inputValue, action) => {
    if (action.action !== "input-blur" && action.action !== "menu-close") {
      const newtag = _.cloneDeep(tags);
      newtag["article_tag"] = inputValue;
      setTags(newtag);
      // modification tracking..
      let newModification = {
        ...modification,
        article_tag: (inputValue && inputValue.id) || null,
      };
      setModification(newModification);
    }
  };
  return (
    <div
      className={`${!isVisible ? "d-none" : ""} mt-3`}
      style={{ textAlign: "left", width: "100%" }}
    >
      <div className="form-group row">
        <div className="col-12">
          <div className="form-group row">
            <div className="col-12">
              <ReactSelect
                isSearchable={true}
                value={
                  tags.article_tag
                    ? { label: tags.article_tag.title, value: tags.article_tag }
                    : null
                }
                onChange={handleSelectArticle}
                options={[{ label: "No Tag", value: null }].concat(
                  articles.map((article) => ({
                    value: article,
                    label: article.title,
                  }))
                )}
                placeholder="Tag a article"
                onInputChange={handleInputArticleChange}
                styles={{
                  option: (provided, state) => ({
                    ...provided,
                    textAlign: "left",
                  }),
                }}
                noOptionsMessage={() => "No Tag"}
              ></ReactSelect>
            </div>
          </div>
          {hot_topic_tags.length > 0 && (
            <div className="form-group row">
              <div className="col-12">
                <ReactSelect
                  isSearchable={true}
                  value={
                    tags.hot_topic
                      ? { value: tags.hot_topic, label: tags.hot_topic.tag }
                      : null
                  }
                  onChange={handleSelectHotTopic}
                  options={[{ label: "None", value: null }, ...hot_topic_tags]}
                  placeholder="Tag a hot topic"
                  styles={{
                    option: (provided, state) => ({
                      ...provided,
                      textAlign: "left",
                    }),
                  }}
                ></ReactSelect>
              </div>
            </div>
          )}
          <div className="form-group row">
            <div className="col-12">
              <ReactSelect
                isSearchable={true}
                value={
                  tags.event_tag
                    ? { label: tags.event_tag.title, value: tags.event_tag }
                    : null
                }
                onChange={handleSelectEvent}
                options={[{ label: "No Tag", value: null }].concat(
                  events.map((event) => ({
                    value: event,
                    label: event.title,
                  }))
                )}
                placeholder="Tag an event"
                onInputChange={handleInputEventChange}
                styles={{
                  option: (provided, state) => ({
                    ...provided,
                    textAlign: "left",
                  }),
                }}
                noOptionsMessage={() => "No Tag"}
              ></ReactSelect>
            </div>
          </div>
          <div className="form-group row">
            <div className="col-12">
              <ReactSelect
                isSearchable={true}
                value={
                  tags.product_tag
                    ? {
                        label: tags.product_tag.caption,
                        value: tags.product_tag,
                      }
                    : null
                }
                onChange={handleSelectProduct}
                options={[{ label: "No Tag", value: null }].concat(
                  products.map((product) => ({
                    value: product,
                    label: product.caption,
                  }))
                )}
                placeholder="Tag a product"
                onInputChange={handleInputProductChange}
                styles={{
                  option: (provided, state) => ({
                    ...provided,
                    textAlign: "left",
                  }),
                }}
                noOptionsMessage={() => "No Tag"}
              ></ReactSelect>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default FeedTags;



// WEBPACK FOOTER //
// ./src/screens/Feeds/components/FeedTags.js